{
  "about.blocks": "제한된 서버들",
  "about.contact": "연락처:",
  "about.default_locale": "기본",
  "about.disclaimer": "Mastodon은 자유 오픈소스 소프트웨어이며, Mastodon gGmbH의 상표입니다",
  "about.domain_blocks.no_reason_available": "사유를 밝히지 않음",
  "about.domain_blocks.preamble": "마스토돈은 일반적으로 연합우주에 있는 어떤 서버의 사용자와도 게시물을 보고 응답을 할 수 있도록 허용합니다. 다음 항목들은 특정한 서버에 대해 만들어 진 예외사항입니다.",
  "about.domain_blocks.silenced.explanation": "명시적으로 찾아보거나 팔로우를 하기 전까지는, 이 서버에 있는 프로필이나 게시물 등을 일반적으로 볼 수 없습니다.",
  "about.domain_blocks.silenced.title": "제한됨",
  "about.domain_blocks.suspended.explanation": "이 서버의 어떤 데이터도 처리되거나, 저장 되거나 공유되지 않고, 이 서버의 어떤 유저와도 상호작용 하거나 대화할 수 없습니다.",
  "about.domain_blocks.suspended.title": "정지됨",
  "about.language_label": "언어",
  "about.not_available": "이 정보는 이 서버에서 사용할 수 없습니다.",
  "about.powered_by": "{mastodon}으로 구동되는 분산 소셜 미디어",
  "about.rules": "서버 규칙",
  "account.account_note_header": "개인 메모",
  "account.activity": "활동",
  "account.add_note": "개인 메모 추가",
  "account.add_or_remove_from_list": "리스트에 추가 혹은 삭제",
  "account.badges.admin": "관리자",
  "account.badges.blocked": "차단함",
  "account.badges.bot": "자동화됨",
  "account.badges.domain_blocked": "차단한 도메인",
  "account.badges.group": "그룹",
  "account.badges.muted": "뮤트함",
  "account.badges.muted_until": "{until}까지 뮤트함",
  "account.block": "@{name} 차단",
  "account.block_domain": "{domain} 도메인 차단",
  "account.block_short": "차단",
  "account.blocked": "차단함",
  "account.blocking": "차단함",
  "account.cancel_follow_request": "팔로우 취소",
  "account.copy": "프로필 링크 복사",
  "account.direct": "@{name} 님에게 개인 멘션",
  "account.disable_notifications": "@{name} 의 게시물 알림 끄기",
  "account.domain_blocking": "도메인 차단함",
  "account.edit_note": "개인 메모 편집",
  "account.edit_profile": "프로필 편집",
  "account.edit_profile_short": "수정",
  "account.enable_notifications": "@{name} 의 게시물 알림 켜기",
  "account.endorse": "프로필에 추천하기",
  "account.familiar_followers_many": "{name1}, {name2} 님 외 내가 아는 {othersCount, plural, other {#}} 명이 팔로우함",
  "account.familiar_followers_one": "{name1} 님이 팔로우함",
  "account.familiar_followers_two": "{name1}, {name2} 님이 팔로우함",
  "account.featured": "추천",
  "account.featured.accounts": "프로필",
  "account.featured.hashtags": "해시태그",
  "account.featured_tags.last_status_at": "{date}에 마지막으로 게시",
  "account.featured_tags.last_status_never": "게시물 없음",
  "account.field_overflow": "내용 전체 보기",
  "account.filters.all": "모든 활동",
  "account.filters.boosts_toggle": "부스트 보기",
  "account.filters.posts_boosts": "게시물과 부스트",
  "account.filters.posts_only": "게시물",
  "account.filters.posts_replies": "게시물과 답장",
  "account.filters.replies_toggle": "답글 보기",
  "account.follow": "팔로우",
  "account.follow_back": "맞팔로우",
  "account.follow_back_short": "맞팔로우",
  "account.follow_request": "팔로우 요청",
  "account.follow_request_cancel": "요청 취소",
  "account.follow_request_cancel_short": "취소",
  "account.follow_request_short": "요청",
  "account.followers": "팔로워",
  "account.followers.empty": "아직 아무도 이 사용자를 팔로우하고 있지 않습니다.",
  "account.followers_counter": "{count, plural, other {팔로워 {counter}명}}",
  "account.followers_you_know_counter": "내가 아는 {counter} 명",
  "account.following": "팔로잉",
  "account.following_counter": "{count, plural, other {팔로잉 {counter}명}}",
  "account.follows.empty": "이 사용자는 아직 아무도 팔로우하고 있지 않습니다.",
  "account.follows_you": "나를 팔로우",
  "account.go_to_profile": "프로필로 이동",
  "account.hide_reblogs": "@{name}의 부스트를 숨기기",
  "account.in_memoriam": "고인의 계정입니다.",
  "account.joined_short": "가입",
  "account.languages": "구독한 언어 변경",
  "account.link_verified_on": "{date}에 이 링크의 소유권이 확인 됨",
  "account.locked_info": "이 계정의 프라이버시 설정은 잠금으로 설정되어 있습니다. 계정 소유자가 수동으로 팔로워를 승인합니다.",
  "account.media": "미디어",
  "account.mention": "@{name} 님에게 멘션",
  "account.menu.add_to_list": "리스트에 추가…",
  "account.menu.block": "계정 차단",
  "account.menu.block_domain": "{domain} 차단",
  "account.menu.copied": "계정 링크를 복사했습니다",
  "account.menu.copy": "링크 복사하기",
  "account.menu.mention": "멘션",
  "account.menu.mute": "계정 뮤트",
  "account.menu.note.description": "나에게만 보입니다",
  "account.menu.open_original_page": "{domain}에서 보기",
  "account.menu.remove_follower": "팔로워 제거",
  "account.menu.report": "계정 신고",
  "account.menu.share": "공유하기…",
  "account.moved_to": "{name} 님은 자신의 새 계정이 다음과 같다고 표시했습니다:",
  "account.mute": "@{name} 뮤트",
  "account.mute_notifications_short": "알림 뮤트",
  "account.mute_short": "뮤트",
  "account.muted": "뮤트됨",
  "account.muting": "뮤트함",
  "account.mutual": "서로 팔로우",
  "account.no_bio": "제공된 설명이 없습니다.",
  "account.node_modal.save": "저장",
  "account.node_modal.title": "개인 메모 추가",
  "account.note.edit_button": "편집",
  "account.open_original_page": "원본 페이지 열기",
  "account.posts": "게시물",
  "account.posts_with_replies": "게시물과 답장",
  "account.remove_from_followers": "팔로워에서 {name} 제거",
  "account.report": "@{name} 신고",
  "account.requested_follow": "{name} 님이 팔로우 요청을 보냈습니다",
  "account.requests_to_follow_you": "팔로우 요청",
  "account.share": "@{name}의 프로필 공유",
  "account.show_reblogs": "@{name}의 부스트 보기",
  "account.statuses_counter": "{count, plural, other {게시물 {counter}개}}",
  "account.unblock": "차단 해제",
  "account.unblock_domain": "도메인 {domain} 차단 해제",
  "account.unblock_domain_short": "차단 해제",
  "account.unblock_short": "차단 해제",
  "account.unendorse": "프로필에 추천하지 않기",
  "account.unfollow": "언팔로우",
  "account.unmute": "@{name} 뮤트 해제",
  "account.unmute_notifications_short": "알림 뮤트 해제",
  "account.unmute_short": "뮤트 해제",
  "account_edit.bio.title": "자기소개",
  "account_edit.bio_modal.add_title": "자기소개 추가",
  "account_edit.bio_modal.edit_title": "자기소개 편집",
  "account_edit.column_button": "완료",
  "account_edit.column_title": "프로필 편집",
  "account_note.placeholder": "클릭하여 노트 추가",
  "admin.dashboard.daily_retention": "가입 후 일별 사용자 유지율",
  "admin.dashboard.monthly_retention": "가입 후 월별 사용자 유지율",
  "admin.dashboard.retention.average": "평균",
  "admin.dashboard.retention.cohort": "가입한 달",
  "admin.dashboard.retention.cohort_size": "새 사용자",
  "admin.impact_report.instance_accounts": "이 계정 프로필들이 지워질 것입니다",
  "admin.impact_report.instance_followers": "우리 사용자들의 팔로워를 잃을 것입니다",
  "admin.impact_report.instance_follows": "저쪽 사용자들의 팔로워를 잃을 것입니다",
  "admin.impact_report.title": "영향 요약",
  "alert.rate_limited.message": "{retry_time, time, medium}에 다시 시도해 주세요.",
  "alert.rate_limited.title": "빈도 제한됨",
  "alert.unexpected.message": "예상하지 못한 에러가 발생했습니다.",
  "alert.unexpected.title": "앗!",
  "alt_text_badge.title": "대체 문구",
  "alt_text_modal.add_alt_text": "대체 텍스트 추가",
  "alt_text_modal.add_text_from_image": "이미지에서 텍스트 추가",
  "alt_text_modal.cancel": "취소",
  "alt_text_modal.change_thumbnail": "썸네일 변경",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "청력 장애가 있는 사람들을 위한 설명을 작성하세요…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "시각 장애가 있는 사람들을 위한 설명을 작성하세요…",
  "alt_text_modal.done": "완료",
  "announcement.announcement": "공지사항",
  "annual_report.announcement.action_build": "랩스토돈 만들기",
  "annual_report.announcement.action_dismiss": "괜찮습니다",
  "annual_report.announcement.action_view": "랩스토돈 보기",
  "annual_report.announcement.description": "지난 한 해 동안의 마스토돈 활동에 대해 자세히 알아보세요.",
  "annual_report.announcement.title": "{year} 랩스토돈 도착",
  "annual_report.nav_item.badge": "신규",
  "annual_report.shared_page.donate": "기부하기",
  "annual_report.shared_page.footer": "마스토돈 팀이 {heart}를 담아 만들었습니다",
  "annual_report.shared_page.footer_server_info": "{username} 님은 마스토돈이 지원하는 많은 커뮤니티 중 하나인 {domain}을 사용하고 있습니다.",
  "annual_report.summary.archetype.booster.desc_public": "{name} 님은 부스트할 게시물을 기다리고 정확한 조준으로 다른 제작자들을 밀어주었습니다.",
  "annual_report.summary.archetype.booster.desc_self": "당신은 부스트할 게시물을 기다리고 정확한 조준으로 다른 제작자들을 밀어주었습니다.",
  "annual_report.summary.archetype.booster.name": "궁수",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "{name} 님이 어딘가에서 자신만의 조용한 방식으로 마스토돈을 즐기고 계셨다는 것을 저희는 알고 있습니다.",
  "annual_report.summary.archetype.lurker.desc_self": "사용자님이 어딘가에서 자신만의 조용한 방식으로 마스토돈을 즐기고 계셨다는 것을 저희는 알고 있습니다.",
  "annual_report.summary.archetype.lurker.name": "금욕주의자",
  "annual_report.summary.archetype.oracle.desc_public": "{name} 님은 답글보다 새로운 글을 많이 작성해 마스토돈을 신선하고 미래지향적으로 만들었습니다.",
  "annual_report.summary.archetype.oracle.desc_self": "당신은 답글보다 새로운 글을 많이 작성해 마스토돈을 신선하고 미래지향적으로 만들었습니다.",
  "annual_report.summary.archetype.oracle.name": "예언자",
  "annual_report.summary.archetype.pollster.desc_public": "{name} 님은 다른 게시물보다 투표를 많이 만들었고 마스토돈에서 호기심을 일궈냈습니다.",
  "annual_report.summary.archetype.pollster.desc_self": "당신은 다른 게시물보다 투표를 많이 만들었고 마스토돈에서 호기심을 일궈냈습니다.",
  "annual_report.summary.archetype.pollster.name": "호기심쟁이",
  "annual_report.summary.archetype.replier.desc_public": "{name} 님은 다른 사람의 게시물에 자주 답글을 남겨 마스토돈에 새로운 논의거리를 만들어냈습니다.",
  "annual_report.summary.archetype.replier.desc_self": "당신은 다른 사람의 게시물에 자주 답글을 남겨 마스토돈에 새로운 논의거리를 만들어냈습니다.",
  "annual_report.summary.archetype.replier.name": "나비",
  "annual_report.summary.archetype.reveal": "내 특성을 확인합니다",
  "annual_report.summary.archetype.reveal_description": "마스토돈의 일원이 되어주셔서 감사합니다! {year} 년엔 어떤 특성을 부여받는지 알아봅시다.",
  "annual_report.summary.archetype.title_public": "{name} 님의 특성",
  "annual_report.summary.archetype.title_self": "당신의 특성",
  "annual_report.summary.close": "닫기",
  "annual_report.summary.copy_link": "링크 복사하기",
  "annual_report.summary.highlighted_post.boost_count": "이 게시물은 {count, plural,other {# 번}} 부스트되었습니다.",
  "annual_report.summary.highlighted_post.favourite_count": "이 게시물은 {count, plural,other {# 번}} 마음에 들었습니다.",
  "annual_report.summary.highlighted_post.reply_count": "이 게시물은 {count, plural, other {# 개}}의 답글을 받았습니다.",
  "annual_report.summary.highlighted_post.title": "가장 인기있는 게시물",
  "annual_report.summary.most_used_app.most_used_app": "가장 많이 사용한 앱",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "가장 많이 사용한 해시태그",
  "annual_report.summary.new_posts.new_posts": "새 게시물",
  "annual_report.summary.percentile.text": "<topLabel>{domain} 사용자의 상위</topLabel><percentage></percentage><bottomLabel>입니다.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "종부세는 안 걷을게요",
  "annual_report.summary.share_elsewhere": "외부로 공유하기",
  "annual_report.summary.share_message": "나는 {archetype} 특성을 부여받았습니다!",
  "annual_report.summary.share_on_mastodon": "마스토돈에 공유하기",
  "attachments_list.unprocessed": "(처리 안 됨)",
  "audio.hide": "소리 숨기기",
  "block_modal.remote_users_caveat": "{domain} 서버에 요청을 보냈습니다. 하지만 일부 서버는 차단 처리 방식이 달라 반영되지 않을 수 있습니다. 또한 공개 게시물은 로그인하지 않은 사용자들에게 계속 노출될 수 있습니다.",
  "block_modal.show_less": "간략히 보기",
  "block_modal.show_more": "더 보기",
  "block_modal.they_cant_mention": "나를 멘션하거나 팔로우 할 수 없습니다.",
  "block_modal.they_cant_see_posts": "상대방이 내 게시물을 볼 수 없게 되며 나도 상대방의 게시물을 볼 수 없게 됩니다.",
  "block_modal.they_will_know": "자신이 차단 당했다는 사실을 확인할 수 있습니다.",
  "block_modal.title": "사용자를 차단할까요?",
  "block_modal.you_wont_see_mentions": "해당 사용자를 멘션한 게시물이 보이지 않게 됩니다.",
  "boost_modal.combo": "다음엔 {combo}를 눌러서 이 과정을 건너뛸 수 있습니다",
  "boost_modal.reblog": "게시물을 부스트할까요?",
  "boost_modal.undo_reblog": "게시물을 부스트 취소할까요?",
  "bundle_column_error.copy_stacktrace": "에러 리포트 복사하기",
  "bundle_column_error.error.body": "요청한 페이지를 렌더링 할 수 없습니다. 저희의 코드에 버그가 있거나, 브라우저 호환성 문제일 수 있습니다.",
  "bundle_column_error.error.title": "으악, 안돼!",
  "bundle_column_error.network.body": "이 페이지를 불러오는 중 오류가 발생했습니다. 일시적으로 서버와의 연결이 불안정한 문제일 수도 있습니다.",
  "bundle_column_error.network.title": "네트워크 오류",
  "bundle_column_error.retry": "다시 시도",
  "bundle_column_error.return": "홈으로 돌아가기",
  "bundle_column_error.routing.body": "요청하신 페이지를 찾을 수 없습니다. 주소창에 적힌 URL이 확실히 맞나요?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "닫기",
  "bundle_modal_error.message": "화면을 불러오는 동안 오류가 발생했습니다.",
  "bundle_modal_error.retry": "다시 시도",
  "carousel.current": "<sr>페이지</sr> {current, number} / {max, number}",
  "carousel.slide": "{max, number} 중 {current, number} 페이지",
  "closed_registrations.other_server_instructions": "마스토돈은 분산화 되어 있기 때문에, 다른 서버에서 계정을 만들더라도 이 서버와 상호작용 할 수 있습니다.",
  "closed_registrations_modal.description": "{domain}은 현재 가입이 불가능합니다. 하지만 마스토돈을 이용하기 위해 꼭 {domain}을 사용할 필요는 없다는 사실을 인지해 두세요.",
  "closed_registrations_modal.find_another_server": "다른 서버 찾기",
  "closed_registrations_modal.preamble": "마스토돈은 분산화 되어 있습니다, 그렇기 때문에 어디에서 계정을 생성하든, 이 서버에 있는 누구와도 팔로우와 상호작용을 할 수 있습니다. 심지어는 스스로 서버를 만드는 것도 가능합니다!",
  "closed_registrations_modal.title": "마스토돈에서 가입",
  "collections.collection_description": "설명",
  "collections.collection_topic": "화제",
  "collections.create_collection": "컬렉션 만들기",
  "collections.delete_collection": "컬렉션 지우기",
  "collections.manage_accounts": "계정 관리하기",
  "collections.new_collection": "새 컬렉션",
  "collections.no_collections_yet": "아직 컬렉션이 없습니다.",
  "collections.view_collection": "컬렉션 보기",
  "collections.visibility_public": "공개",
  "column.about": "정보",
  "column.blocks": "차단한 사용자",
  "column.bookmarks": "북마크",
  "column.community": "로컬 타임라인",
  "column.create_list": "리스트 만들기",
  "column.direct": "개인 멘션",
  "column.directory": "프로필 둘러보기",
  "column.domain_blocks": "차단한 도메인",
  "column.edit_list": "리스트 편집",
  "column.favourites": "좋아요",
  "column.firehose": "실시간 피드",
  "column.firehose_local": "이 서버에 대한 실시간 피드",
  "column.firehose_singular": "실시간 피드",
  "column.follow_requests": "팔로우 요청",
  "column.home": "홈",
  "column.list_members": "리스트 구성원 관리",
  "column.lists": "리스트",
  "column.mutes": "뮤트한 사용자",
  "column.notifications": "알림",
  "column.pins": "고정된 게시물",
  "column.public": "연합 타임라인",
  "column_back_button.label": "돌아가기",
  "column_header.hide_settings": "설정 숨기기",
  "column_header.moveLeft_settings": "컬럼을 왼쪽으로 이동",
  "column_header.moveRight_settings": "컬럼을 오른쪽으로 이동",
  "column_header.pin": "고정하기",
  "column_header.show_settings": "설정 보이기",
  "column_header.unpin": "고정 해제",
  "column_search.cancel": "취소",
  "combobox.loading": "불러오는 중",
  "community.column_settings.local_only": "로컬만",
  "community.column_settings.media_only": "미디어만",
  "community.column_settings.remote_only": "원격지만",
  "compose.error.blank_post": "빈 게시물은 게시할 수 없습니다.",
  "compose.language.change": "언어 변경",
  "compose.language.search": "언어 검색...",
  "compose.published.body": "게시하였습니다.",
  "compose.published.open": "열기",
  "compose.saved.body": "게시물이 저장되었습니다.",
  "compose_form.direct_message_warning_learn_more": "더 알아보기",
  "compose_form.encryption_warning": "마스토돈의 게시물들은 종단간 암호화가 되지 않습니다. 민감한 정보를 마스토돈을 통해 전달하지 마세요.",
  "compose_form.hashtag_warning": "이 게시물은 전체공개가 아니기 때문에 어떤 해시태그로도 검색 되지 않습니다. 전체공개로 게시 된 게시물만이 해시태그로 검색될 수 있습니다.",
  "compose_form.lock_disclaimer": "이 계정은 {locked}상태가 아닙니다. 누구나 이 계정을 팔로우 하여 팔로워 전용의 게시물을 볼 수 있습니다.",
  "compose_form.lock_disclaimer.lock": "비공개",
  "compose_form.placeholder": "지금 무슨 생각을 하고 있나요?",
  "compose_form.poll.duration": "투표 기간",
  "compose_form.poll.multiple": "다중 선택",
  "compose_form.poll.option_placeholder": "{number}번째 옵션",
  "compose_form.poll.single": "단일 선택",
  "compose_form.poll.switch_to_multiple": "다중 선택이 가능한 투표로 변경",
  "compose_form.poll.switch_to_single": "단일 선택 투표로 변경",
  "compose_form.poll.type": "형식",
  "compose_form.publish": "게시",
  "compose_form.reply": "답장",
  "compose_form.save_changes": "수정",
  "compose_form.spoiler.marked": "열람주의 제거",
  "compose_form.spoiler.unmarked": "열람 주의 문구 추가",
  "compose_form.spoiler_placeholder": "내용 경고 (선택사항)",
  "confirmation_modal.cancel": "취소",
  "confirmations.block.confirm": "차단",
  "confirmations.delete.confirm": "삭제",
  "confirmations.delete.message": "정말로 이 게시물을 삭제하시겠습니까?",
  "confirmations.delete.title": "게시물을 삭제할까요?",
  "confirmations.delete_list.confirm": "삭제",
  "confirmations.delete_list.message": "정말로 이 리스트를 영구적으로 삭제하시겠습니까?",
  "confirmations.delete_list.title": "리스트를 삭제할까요?",
  "confirmations.discard_draft.confirm": "삭제 및 계속",
  "confirmations.discard_draft.edit.cancel": "계속 편집",
  "confirmations.discard_draft.edit.message": "편집중인 게시물 변경사항을 모두 잃게 됩니다.",
  "confirmations.discard_draft.edit.title": "게시물 변경사항을 삭제할까요?",
  "confirmations.discard_draft.post.cancel": "초안으로 돌아가기",
  "confirmations.discard_draft.post.message": "계속 진행하면 현재 작성 중인 게시물이 삭제됩니다.",
  "confirmations.discard_draft.post.title": "게시물 초안을 삭제할까요?",
  "confirmations.discard_edit_media.confirm": "저장 안함",
  "confirmations.discard_edit_media.message": "미디어 설명이나 미리보기에 대한 저장하지 않은 변경사항이 있습니다. 버리시겠습니까?",
  "confirmations.follow_to_list.confirm": "팔로우하고 리스트에 추가",
  "confirmations.follow_to_list.message": "리스트에 추가하려면 {name} 님을 팔로우해야 합니다.",
  "confirmations.follow_to_list.title": "팔로우할까요?",
  "confirmations.logout.confirm": "로그아웃",
  "confirmations.logout.message": "정말로 로그아웃 하시겠습니까?",
  "confirmations.logout.title": "로그아웃 할까요?",
  "confirmations.missing_alt_text.confirm": "대체 텍스트 추가",
  "confirmations.missing_alt_text.message": "대체 텍스트가 없는 미디어가 포함되어 있습니다. 설명을 추가하면 더 많은 사람들이 내 콘텐츠에 접근할 수 있습니다.",
  "confirmations.missing_alt_text.secondary": "그냥 게시하기",
  "confirmations.missing_alt_text.title": "대체 텍스트를 추가할까요? ",
  "confirmations.mute.confirm": "뮤트",
  "confirmations.private_quote_notify.cancel": "편집으로 돌아가기",
  "confirmations.private_quote_notify.confirm": "게시",
  "confirmations.private_quote_notify.do_not_show_again": "이 메시지를 다시 표시하지 않음",
  "confirmations.private_quote_notify.message": "인용하려는 사용자 및 멘션된 다른 사람들에게 알림이 전송되며 상대방이 나를 팔로우하지 않더라도 해당 게시물을 볼 수 있습니다.",
  "confirmations.private_quote_notify.title": "팔로워 및 언급된 사용자에게 공유하시겠습니까?",
  "confirmations.quiet_post_quote_info.dismiss": "다시 보지 않기",
  "confirmations.quiet_post_quote_info.got_it": "알겠습니다",
  "confirmations.quiet_post_quote_info.message": "조용한 공개 게시물을 인용하면 해당 게시물은 트렌드 타임라인에 노출되지 않습니다.",
  "confirmations.quiet_post_quote_info.title": "조용한 공개 게시물 인용하기",
  "confirmations.redraft.confirm": "삭제하고 다시 쓰기",
  "confirmations.redraft.message": "정말로 이 게시물을 삭제하고 다시 쓰시겠습니까? 해당 게시물에 대한 부스트와 좋아요를 잃게 되고 원본에 대한 답장은 연결 되지 않습니다.",
  "confirmations.redraft.title": "삭제하고 다시 작성할까요?",
  "confirmations.remove_from_followers.confirm": "팔로워 제거",
  "confirmations.remove_from_followers.message": "{name} 님이 나를 팔로우하지 않게 됩니다. 계속할까요?",
  "confirmations.remove_from_followers.title": "팔로워를 제거할까요?",
  "confirmations.revoke_quote.confirm": "게시물 삭제",
  "confirmations.revoke_quote.message": "이 작업은 되돌릴 수 없습니다.",
  "confirmations.revoke_quote.title": "게시물을 지울까요?",
  "confirmations.unblock.confirm": "차단 해제",
  "confirmations.unblock.title": "{name} 님을 차단 해제할까요?",
  "confirmations.unfollow.confirm": "팔로우 해제",
  "confirmations.unfollow.title": "{name} 님을 언팔로우 할까요?",
  "confirmations.withdraw_request.confirm": "요청 삭제",
  "confirmations.withdraw_request.title": "{name} 님에 대한 팔로우 요청을 취소할까요?",
  "content_warning.hide": "게시물 숨기기",
  "content_warning.show": "무시하고 보기",
  "content_warning.show_more": "더 보기",
  "conversation.delete": "대화 삭제",
  "conversation.mark_as_read": "읽은 상태로 표시",
  "conversation.open": "대화 보기",
  "conversation.with": "{names} 님과",
  "copy_icon_button.copied": "클립보드에 복사됨",
  "copypaste.copied": "복사됨",
  "copypaste.copy_to_clipboard": "클립보드에 복사",
  "directory.federated": "알려진 연합우주로부터",
  "directory.local": "{domain}에서만",
  "directory.new_arrivals": "새로운 사람들",
  "directory.recently_active": "최근 활동",
  "disabled_account_banner.account_settings": "계정 설정",
  "disabled_account_banner.text": "당신의 계정 {disabledAccount}는 현재 비활성화 상태입니다.",
  "dismissable_banner.community_timeline": "여기 있는 것들은 계정이 {domain}에 있는 사람들의 최근 공개 게시물들입니다.",
  "dismissable_banner.dismiss": "지우기",
  "dismissable_banner.public_timeline": "이 게시물들은 {domain}에 있는 사람들이 팔로우하는 페디버스 사용자들의 최신 공개 게시물입니다.",
  "domain_block_modal.block": "서버 차단",
  "domain_block_modal.block_account_instead": "대신 @{name} 차단",
  "domain_block_modal.they_can_interact_with_old_posts": "이 서버에 있는 사람들이 내 예전 게시물에 상호작용할 수는 있습니다.",
  "domain_block_modal.they_cant_follow": "이 서버의 누구도 나를 팔로우 할 수 없습니다.",
  "domain_block_modal.they_wont_know": "내가 차단했다는 사실을 모를 것입니다.",
  "domain_block_modal.title": "도메인을 차단할까요?",
  "domain_block_modal.you_will_lose_num_followers": "{followersCount, plural, other {{followersCountDisplay} 명의 팔로워}}와 {followingCount, plural, other {{followingCountDisplay} 명의 팔로우}}를 잃게 됩니다.",
  "domain_block_modal.you_will_lose_relationships": "이 서버의 팔로워와 팔로우를 모두 잃게 됩니다.",
  "domain_block_modal.you_wont_see_posts": "이 서버 사용자의 게시물이나 알림을 보지 않게 됩니다.",
  "domain_pill.activitypub_lets_connect": "이것은 마스토돈 뿐만이 아니라 다른 소셜 앱들을 넘나들며 사람들을 연결하고 상호작용 할 수 있게 합니다.",
  "domain_pill.activitypub_like_language": "액티비티펍은 마스토돈이 다른 소셜 네트워크와 대화할 때 사용하는 언어입니다.",
  "domain_pill.server": "서버",
  "domain_pill.their_handle": "이 사람의 핸들:",
  "domain_pill.their_server": "작성한 모든 글들이 담겨있는 디지털 공간입니다.",
  "domain_pill.their_username": "서버 내에서 사용되는 고유 식별자입니다. 서버마다 동일한 사용자명이 존재할 수 있습니다.",
  "domain_pill.username": "사용자명",
  "domain_pill.whats_in_a_handle": "핸들엔 무엇이 담겨 있나요?",
  "domain_pill.who_they_are": "핸들은 사용자가 누구이며 어디에 있는지 알려주므로 <button>액티비티펍 기반 플랫폼</button> 어디에서든 사람들과 자유롭게 소통할 수 있습니다.",
  "domain_pill.who_you_are": "사용자의 핸들은 본인이 누구이며 어디에 있는지 나타내므로 <button>액티비티펍 기반 플랫폼</button> 어디에서든 사용자님과 소통할 수 있습니다.",
  "domain_pill.your_handle": "내 핸들:",
  "domain_pill.your_server": "작성한 모든 글들이 담기는 디지털 공간입니다. 지금 서버가 마음에 들지 않나요? 언제든지 팔로워와 함께 서버를 이전할 수 있습니다.",
  "domain_pill.your_username": "이 서버에서 유일한 내 식별자입니다. 다른 서버에서 같은 사용자명을 가진 사용자를 찾을 수도 있습니다.",
  "dropdown.empty": "옵션 선택",
  "embed.instructions": "아래 코드를 복사하여 이 게시물을 사용자님의 웹사이트에 임베드하세요.",
  "embed.preview": "이렇게 표시됩니다:",
  "emoji_button.activity": "활동",
  "emoji_button.clear": "지우기",
  "emoji_button.custom": "커스텀",
  "emoji_button.flags": "깃발",
  "emoji_button.food": "음식과 마실것",
  "emoji_button.label": "에모지 추가",
  "emoji_button.nature": "자연",
  "emoji_button.not_found": "해당하는 에모지가 없습니다",
  "emoji_button.objects": "물건",
  "emoji_button.people": "사람들",
  "emoji_button.recent": "자주 사용됨",
  "emoji_button.search": "검색...",
  "emoji_button.search_results": "검색 결과",
  "emoji_button.symbols": "기호",
  "emoji_button.travel": "여행과 장소",
  "empty_column.account_featured.me": "아직 아무 것도 추천하지 않았습니다. 자주 사용하는 해시태그, 친구의 계정까지 내 계정에서 추천할 수 있다는 것을 알고 계셨나요?",
  "empty_column.account_featured.other": "{acct} 님은 아직 아무 것도 추천하지 않았습니다. 자주 사용하는 해시태그, 친구의 계정까지 내 계정에서 추천할 수 있다는 것을 알고 계셨나요?",
  "empty_column.account_featured_other.unknown": "이 계정은 아직 아무 것도 추천하지 않았습니다.",
  "empty_column.account_hides_collections": "이 사용자는 이 정보를 사용할 수 없도록 설정했습니다",
  "empty_column.account_suspended": "계정 정지됨",
  "empty_column.account_timeline": "이곳에는 게시물이 없습니다!",
  "empty_column.account_unavailable": "프로필 사용 불가",
  "empty_column.blocks": "아직 아무도 차단하지 않았습니다.",
  "empty_column.bookmarked_statuses": "아직 북마크에 저장한 게시물이 없습니다. 게시물을 북마크 지정하면 여기에 나타납니다.",
  "empty_column.community": "로컬 타임라인에 아무것도 없습니다. 아무거나 적어 보세요!",
  "empty_column.direct": "개인 멘션이 없습니다. 보내거나 받으면 여기에 표시됩니다.",
  "empty_column.disabled_feed": "이 피드는 서버 관리자에 의해 비활성화되었습니다.",
  "empty_column.domain_blocks": "아직 차단한 도메인이 없습니다.",
  "empty_column.explore_statuses": "아직 유행하는 것이 없습니다. 나중에 다시 확인하세요!",
  "empty_column.favourited_statuses": "아직 좋아요한 게시물이 없습니다. 게시물을 좋아요 하면 여기에 나타납니다.",
  "empty_column.favourites": "아직 아무도 이 게시물에 좋아요를 표시하지 않았습니다. 누군가 좋아요를 표시하면 여기서 확인할 수 있습니다.",
  "empty_column.follow_requests": "아직 팔로우 요청이 없습니다. 요청을 받았을 때 여기에 나타납니다.",
  "empty_column.followed_tags": "아직 아무 해시태그도 팔로우하고 있지 않습니다. 해시태그를 팔로우하면, 여기에 표시됩니다.",
  "empty_column.hashtag": "이 해시태그는 아직 사용되지 않았습니다.",
  "empty_column.home": "당신의 홈 타임라인은 비어있습니다! 더 많은 사람을 팔로우하여 채워보세요.",
  "empty_column.list": "리스트에 아직 아무것도 없습니다. 리스트의 누군가가 게시물을 올리면 여기에 나타납니다.",
  "empty_column.mutes": "아직 아무도 뮤트하지 않았습니다.",
  "empty_column.notification_requests": "깔끔합니다! 여기엔 아무 것도 없습니다. 알림을 받게 되면 설정에 따라 여기에 나타나게 됩니다.",
  "empty_column.notifications": "아직 알림이 없습니다. 다른 사람들이 당신에게 반응했을 때, 여기에서 볼 수 있습니다.",
  "empty_column.public": "여기엔 아직 아무 것도 없습니다! 공개적으로 무언가 포스팅하거나, 다른 서버의 사용자를 팔로우 해서 채워보세요",
  "error.no_hashtag_feed_access": "이 해시태그를 확인하고 팔로우하려면 가입 또는 로그인하세요.",
  "error.unexpected_crash.explanation": "버그 혹은 브라우저 호환성 문제로 이 페이지를 불러올 수 없습니다.",
  "error.unexpected_crash.explanation_addons": "이 페이지를 불러올 수 없습니다. 브라우저 확장 프로그램이나 자동 번역 도구로 인해 발생된 오류일 수 있습니다.",
  "error.unexpected_crash.next_steps": "페이지를 새로고침 해보세요. 그래도 해결되지 않는 경우, 다른 브라우저나 네이티브 앱으로도 마스토돈을 이용하실 수 있습니다.",
  "error.unexpected_crash.next_steps_addons": "해당 기능을 비활성화한 뒤 다시 시도해 보세요. 여전히 해결되지 않는다면 다른 브라우저나 앱을 통해 마스토돈을 이용하실 수 있습니다.",
  "errors.unexpected_crash.copy_stacktrace": "에러 내용을 클립보드에 복사",
  "errors.unexpected_crash.report_issue": "문제 신고",
  "explore.suggested_follows": "사람들",
  "explore.title": "유행 중",
  "explore.trending_links": "소식",
  "explore.trending_statuses": "게시물",
  "explore.trending_tags": "해시태그",
  "featured_carousel.current": "<sr>게시물</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {고정된 게시물}}",
  "featured_carousel.slide": "{max, number} 중 {current, number} 번째 게시물",
  "filter_modal.added.context_mismatch_explanation": "이 필터 카테고리는 당신이 이 게시물에 접근한 문맥에 적용되지 않습니다. 만약 이 문맥에서도 필터되길 원한다면, 필터를 수정해야 합니다.",
  "filter_modal.added.context_mismatch_title": "문맥 불일치!",
  "filter_modal.added.expired_explanation": "이 필터 카테고리는 만료되었습니다, 적용하려면 만료 일자를 변경할 필요가 있습니다.",
  "filter_modal.added.expired_title": "만료된 필터!",
  "filter_modal.added.review_and_configure": "이 필터 카테고리를 검토하거나 나중에 더 설정하려면, {settings_link}로 가십시오.",
  "filter_modal.added.review_and_configure_title": "필터 설정",
  "filter_modal.added.settings_link": "설정 페이지",
  "filter_modal.added.short_explanation": "이 게시물을 다음 필터 카테고리에 추가되었습니다: {title}.",
  "filter_modal.added.title": "필터 추가됨!",
  "filter_modal.select_filter.context_mismatch": "이 문맥에 적용되지 않습니다",
  "filter_modal.select_filter.expired": "만료됨",
  "filter_modal.select_filter.prompt_new": "새 카테고리: {name}",
  "filter_modal.select_filter.search": "검색 또는 생성",
  "filter_modal.select_filter.subtitle": "기존의 카테고리를 사용하거나 새로 하나를 만듧니다",
  "filter_modal.select_filter.title": "이 게시물을 필터",
  "filter_modal.title.status": "게시물 필터",
  "filter_warning.matches_filter": "\"<span>{title}</span>\" 필터에 걸림",
  "filtered_notifications_banner.pending_requests": "알 수도 있는 {count, plural, =0 {0 명} one {한 명} other {# 명}}의 사람들로부터",
  "filtered_notifications_banner.title": "걸러진 알림",
  "firehose.all": "모두",
  "firehose.local": "이 서버",
  "firehose.remote": "다른 서버",
  "follow_request.authorize": "승인",
  "follow_request.reject": "거부",
  "follow_requests.unlocked_explanation": "사용자님의 계정이 잠금 상태는 아니지만, {domain} 관리자는 사용자님이 직접 이 계정들의 팔로우 요청을 검토하기를 원하실 수 있다고 판단했습니다.",
  "follow_suggestions.curated_suggestion": "스태프의 추천",
  "follow_suggestions.dismiss": "다시 보지 않기",
  "follow_suggestions.featured_longer": "{domain} 팀이 손수 고름",
  "follow_suggestions.friends_of_friends_longer": "내가 팔로우한 사람들 사이에서 인기",
  "follow_suggestions.hints.featured": "이 프로필은 {domain} 팀이 손수 선택했습니다.",
  "follow_suggestions.hints.friends_of_friends": "이 프로필은 내가 팔로우 하는 사람들에게 인기가 있습니다.",
  "follow_suggestions.hints.most_followed": "이 프로필은 {domain}에서 가장 많이 팔로우 된 사람들 중 하나입니다.",
  "follow_suggestions.hints.most_interactions": "이 프로필은 최근 {domain}에서 많은 관심을 받았습니다.",
  "follow_suggestions.hints.similar_to_recently_followed": "이 프로필은 내가 최근에 팔로우 한 프로필들과 유사합니다.",
  "follow_suggestions.personalized_suggestion": "개인화된 추천",
  "follow_suggestions.popular_suggestion": "인기있는 추천",
  "follow_suggestions.popular_suggestion_longer": "{domain}에서 인기",
  "follow_suggestions.similar_to_recently_followed_longer": "내가 최근에 팔로우 한 프로필들과 유사",
  "follow_suggestions.view_all": "모두 보기",
  "follow_suggestions.who_to_follow": "팔로우할 만한 사람",
  "followed_tags": "팔로우 중인 해시태그",
  "footer.about": "정보",
  "footer.about_mastodon": "마스토돈 정보",
  "footer.about_server": "{domain} 소개",
  "footer.about_this_server": "정보",
  "footer.directory": "프로필 책자",
  "footer.get_app": "앱 다운로드하기",
  "footer.keyboard_shortcuts": "키보드 단축키",
  "footer.privacy_policy": "개인정보처리방침",
  "footer.source_code": "소스코드 보기",
  "footer.status": "상태",
  "footer.terms_of_service": "이용 약관",
  "generic.saved": "저장됨",
  "getting_started.heading": "시작하기",
  "hashtag.admin_moderation": "#{name}에 대한 중재화면 열기",
  "hashtag.browse": "#{hashtag}의 게시물 둘러보기",
  "hashtag.browse_from_account": "@{name}의 #{hashtag} 게시물 둘러보기",
  "hashtag.column_header.tag_mode.all": "및 {additional}",
  "hashtag.column_header.tag_mode.any": "또는 {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} 제외",
  "hashtag.column_settings.select.no_options_message": "추천할 내용이 없습니다",
  "hashtag.column_settings.select.placeholder": "해시태그를 입력하세요…",
  "hashtag.column_settings.tag_mode.all": "모두",
  "hashtag.column_settings.tag_mode.any": "어느것이든",
  "hashtag.column_settings.tag_mode.none": "이것들을 제외하고",
  "hashtag.column_settings.tag_toggle": "이 열에 추가 해시태그 포함",
  "hashtag.counter_by_accounts": "{count, plural, other {참여자 {counter}명}}",
  "hashtag.counter_by_uses": "{count, plural, other {게시물 {counter}개}}",
  "hashtag.counter_by_uses_today": "오늘 {count, plural, other {{counter} 개의 게시물}}",
  "hashtag.feature": "프로필에 추천하기",
  "hashtag.follow": "해시태그 팔로우",
  "hashtag.mute": "#{hashtag} 뮤트",
  "hashtag.unfeature": "프로필에 추천하지 않기",
  "hashtag.unfollow": "해시태그 팔로우 해제",
  "hashtags.and_other": "…및 {count, plural,other {#개}}",
  "hints.profiles.followers_may_be_missing": "이 프로필의 팔로워 목록은 일부 누락되었을 수 있습니다.",
  "hints.profiles.follows_may_be_missing": "이 프로필의 팔로우 목록은 일부 누락되었을 수 있습니다.",
  "hints.profiles.posts_may_be_missing": "이 프로필의 게시물은 일부 누락되었을 수 있습니다.",
  "hints.profiles.see_more_followers": "{domain}에서 더 많은 팔로워 보기",
  "hints.profiles.see_more_follows": "{domain}에서 더 많은 팔로우 보기",
  "hints.profiles.see_more_posts": "{domain}에서 더 많은 게시물 보기",
  "home.column_settings.show_quotes": "인용 보기",
  "home.column_settings.show_reblogs": "부스트 표시",
  "home.column_settings.show_replies": "답글 표시",
  "home.hide_announcements": "공지사항 숨기기",
  "home.pending_critical_update.body": "서둘러 마스토돈 서버를 업데이트하세요!",
  "home.pending_critical_update.link": "업데이트 보기",
  "home.pending_critical_update.title": "긴급 보안 업데이트가 있습니다!",
  "home.show_announcements": "공지사항 보기",
  "ignore_notifications_modal.disclaimer": "사용자들은 그들의 알림이 무시되었다는 사실을 알 수 없습니다. 알림을 무시하더라도 해당 사용자가 보내는 메세지는 전송됩니다.",
  "ignore_notifications_modal.filter_instead": "대신 필터로 거르기",
  "ignore_notifications_modal.filter_to_act_users": "여전히 사용자를 수락, 거절, 신고할 수 있습니다",
  "ignore_notifications_modal.filter_to_avoid_confusion": "필터링은 혼란을 예방하는데 도움이 될 수 있습니다",
  "ignore_notifications_modal.filter_to_review_separately": "걸러진 알림들을 개별적으로 검토할 수 있습니다",
  "ignore_notifications_modal.ignore": "알림 무시",
  "ignore_notifications_modal.limited_accounts_title": "중재된 계정의 알림을 무시할까요?",
  "ignore_notifications_modal.new_accounts_title": "새 계정의 알림을 무시할까요?",
  "ignore_notifications_modal.not_followers_title": "나를 팔로우하지 않는 사람들의 알림을 무시할까요?",
  "ignore_notifications_modal.not_following_title": "내가 팔로우하지 않는 사람들의 알림을 무시할까요?",
  "ignore_notifications_modal.private_mentions_title": "요청하지 않은 개인 멘션 알림을 무시할까요?",
  "info_button.label": "도움말",
  "info_button.what_is_alt_text": "<h1>대체 텍스트가 무엇인가요?</h1> <p>대체 텍스트는 저시력자, 낮은 인터넷 대역폭 사용자, 더 자세한 문맥을 위해 이미지에 대한 설명을 제공하는 것입니다.</p> <p>깔끔하고 간결하고 객관적인 대체 텍스트를 작성해 모두가 이해하기 쉽게 만들고 접근성이 높아질 수 있습니다.</p><ul><li>중요한 요소에 중점을 두세요</li> <li>이미지 안의 글자를 요약하세요</li> <li>정형화된 문장 구조를 사용하세요</li> <li>중복된 정보를 피하세요</li> <li>복잡한 시각자료(도표나 지도 같은)에선 추세와 주요 결과에 중점을 두세요</li> </ul>",
  "interaction_modal.action": "{name} 님의 게시물과 상호작용하려면 이용 중인 마스토돈 서버 계정으로 로그인하세요.",
  "interaction_modal.go": "이동",
  "interaction_modal.no_account_yet": "아직 계정이 없나요?",
  "interaction_modal.on_another_server": "다른 서버에",
  "interaction_modal.on_this_server": "이 서버에서",
  "interaction_modal.title": "로그인해서 계속하기",
  "interaction_modal.username_prompt": "예시: {example}",
  "intervals.full.days": "{number} 일",
  "intervals.full.hours": "{number} 시간",
  "intervals.full.minutes": "{number} 분",
  "keyboard_shortcuts.back": "뒤로가기",
  "keyboard_shortcuts.blocked": "차단된 사용자 목록 열기",
  "keyboard_shortcuts.boost": "게시물 부스트",
  "keyboard_shortcuts.column": "해당 컬럼에 포커스",
  "keyboard_shortcuts.compose": "작성창에 포커스",
  "keyboard_shortcuts.description": "설명",
  "keyboard_shortcuts.down": "리스트에서 아래로 이동",
  "keyboard_shortcuts.enter": "게시물 열기",
  "keyboard_shortcuts.favourite": "게시물 좋아요",
  "keyboard_shortcuts.favourites": "좋아요 목록 열기",
  "keyboard_shortcuts.federated": "연합 타임라인 열기",
  "keyboard_shortcuts.heading": "키보드 단축키",
  "keyboard_shortcuts.home": "홈 타임라인 열기",
  "keyboard_shortcuts.hotkey": "핫키",
  "keyboard_shortcuts.legend": "이 개요 표시",
  "keyboard_shortcuts.load_more": "\"더 보기\" 버튼에 포커스",
  "keyboard_shortcuts.local": "로컬 타임라인 열기",
  "keyboard_shortcuts.mention": "작성자에게 멘션",
  "keyboard_shortcuts.muted": "뮤트된 사용자 목록 열기",
  "keyboard_shortcuts.my_profile": "내 프로필 열기",
  "keyboard_shortcuts.notifications": "알림 컬럼 열기",
  "keyboard_shortcuts.open_media": "미디어 열기",
  "keyboard_shortcuts.pinned": "고정 게시물 리스트 열기",
  "keyboard_shortcuts.profile": "작성자의 프로필 열기",
  "keyboard_shortcuts.quote": "게시물 인용",
  "keyboard_shortcuts.reply": "게시물에 답장",
  "keyboard_shortcuts.requests": "팔로우 요청 리스트 열기",
  "keyboard_shortcuts.search": "검색창에 포커스",
  "keyboard_shortcuts.spoilers": "CW 필드를 보이거나 숨기기",
  "keyboard_shortcuts.start": "\"시작하기\" 컬럼 열기",
  "keyboard_shortcuts.toggle_hidden": "CW로 가려진 텍스트를 표시/비표시",
  "keyboard_shortcuts.toggle_sensitivity": "미디어 보이기/숨기기",
  "keyboard_shortcuts.toot": "새 게시물 작성",
  "keyboard_shortcuts.top": "목록의 최상단으로 이동",
  "keyboard_shortcuts.translate": "게시물 번역",
  "keyboard_shortcuts.unfocus": "작성창에서 포커스 해제",
  "keyboard_shortcuts.up": "리스트에서 위로 이동",
  "learn_more_link.got_it": "확인",
  "learn_more_link.learn_more": "더 알아보기",
  "lightbox.close": "닫기",
  "lightbox.next": "다음",
  "lightbox.previous": "이전",
  "lightbox.zoom_in": "실제 크기에 맞춰 보기",
  "lightbox.zoom_out": "화면 크기에 맞춰 보기",
  "limited_account_hint.action": "그래도 프로필 보기",
  "limited_account_hint.title": "이 프로필은 {domain}의 중재자에 의해 숨겨진 상태입니다.",
  "link_preview.author": "{name}",
  "link_preview.more_from_author": "{name} 프로필 보기",
  "link_preview.shares": "{count, plural, other {{counter} 개의 게시물}}",
  "lists.add_member": "추가",
  "lists.add_to_list": "리스트에 추가",
  "lists.add_to_lists": "리스트에 {name} 추가",
  "lists.create": "생성",
  "lists.create_a_list_to_organize": "새 리스트를 만들어 홈 피드를 정리하세요",
  "lists.create_list": "리스트 만들기",
  "lists.delete": "리스트 삭제",
  "lists.done": "완료",
  "lists.edit": "리스트 편집",
  "lists.exclusive": "구성원을 홈에서 숨기기",
  "lists.exclusive_hint": "이 리스트에 추가한 사용자는 중복으로 표시되는 것을 막기 위해 홈 피드에서 숨겨집니다.",
  "lists.find_users_to_add": "추가할 사용자 검색",
  "lists.list_members_count": "{count, plural, other {# 명}}",
  "lists.list_name": "리스트 이름",
  "lists.new_list_name": "새 리스트 이름",
  "lists.no_lists_yet": "아직 아무 리스트도 없습니다.",
  "lists.no_members_yet": "아직 구성원이 없습니다.",
  "lists.no_results_found": "결과가 없습니다.",
  "lists.remove_member": "삭제",
  "lists.replies_policy.followed": "팔로우 한 사용자 누구나에게",
  "lists.replies_policy.list": "리스트의 구성원에게",
  "lists.replies_policy.none": "모두 제외",
  "lists.save": "저장",
  "lists.search": "검색",
  "lists.show_replies_to": "리스트 구성원의 답글또한 포함하기",
  "load_pending": "{count, plural, other {#}} 개의 새 항목",
  "loading_indicator.label": "불러오는 중...",
  "media_gallery.hide": "숨기기",
  "moved_to_account_banner.text": "당신의 계정 {disabledAccount}는 {movedToAccount}로 이동하였기 때문에 현재 비활성화 상태입니다.",
  "mute_modal.hide_from_notifications": "알림에서 숨기기",
  "mute_modal.hide_options": "옵션 숨기기",
  "mute_modal.indefinite": "내가 뮤트를 해제하기 전까지",
  "mute_modal.show_options": "옵션 보기",
  "mute_modal.they_can_mention_and_follow": "그들은 사용자님을 멘션하거나 팔로우할 수 있지만, 사용자님에게는 보이지 않습니다.",
  "mute_modal.they_wont_know": "상대방은 자신이 뮤트되었다는 사실을 알 수 없습니다.",
  "mute_modal.title": "사용자를 뮤트할까요?",
  "mute_modal.you_wont_see_mentions": "그를 멘션하는 게시물을 더는 보지 않게 됩니다.",
  "mute_modal.you_wont_see_posts": "상대방은 사용자님의 게시물을 볼 수 있지만 사용자님에게는 상대방의 게시물이 보이지 않습니다.",
  "navigation_bar.about": "정보",
  "navigation_bar.account_settings": "암호 및 보안",
  "navigation_bar.administration": "관리",
  "navigation_bar.advanced_interface": "고급 웹 인터페이스에서 열기",
  "navigation_bar.automated_deletion": "게시물 자동 삭제",
  "navigation_bar.blocks": "차단한 사용자",
  "navigation_bar.bookmarks": "북마크",
  "navigation_bar.direct": "개인 멘션",
  "navigation_bar.domain_blocks": "차단한 도메인",
  "navigation_bar.favourites": "좋아요",
  "navigation_bar.filters": "뮤트한 단어",
  "navigation_bar.follow_requests": "팔로우 요청",
  "navigation_bar.followed_tags": "팔로우 중인 해시태그",
  "navigation_bar.follows_and_followers": "팔로우와 팔로워",
  "navigation_bar.import_export": "가져오기 & 내보내기",
  "navigation_bar.lists": "리스트",
  "navigation_bar.live_feed_local": "라이브 피드 (로컬)",
  "navigation_bar.live_feed_public": "라이브 피드 (공개)",
  "navigation_bar.logout": "로그아웃",
  "navigation_bar.moderation": "중재",
  "navigation_bar.more": "더 보기",
  "navigation_bar.mutes": "뮤트한 사용자",
  "navigation_bar.opened_in_classic_interface": "게시물, 계정, 기타 특정 페이지들은 기본적으로 기존 웹 인터페이스로 열리게 됩니다.",
  "navigation_bar.preferences": "환경설정",
  "navigation_bar.privacy_and_reach": "개인정보와 도달",
  "navigation_bar.search": "검색",
  "navigation_bar.search_trends": "검색 / 유행",
  "navigation_panel.collapse_followed_tags": "팔로우 중인 해시태그 메뉴 접기",
  "navigation_panel.collapse_lists": "리스트 메뉴 접기",
  "navigation_panel.expand_followed_tags": "팔로우 중인 해시태그 메뉴 펼치기",
  "navigation_panel.expand_lists": "리스트 메뉴 펼치기",
  "not_signed_in_indicator.not_signed_in": "이 정보에 접근하려면 로그인을 해야 합니다.",
  "notification.admin.report": "{name} 님이 {target}를 신고했습니다",
  "notification.admin.report_account": "{name} 님이 {target}의 게시물 {count, plural, other {# 개}}를 {category} 사유로 신고했습니다",
  "notification.admin.report_account_other": "{name} 님이 {target}의 게시물 {count, plural, other {# 개}}를 신고했습니다",
  "notification.admin.report_statuses": "{name} 님이 {target}을 {category}로 신고했습니다",
  "notification.admin.report_statuses_other": "{name} 님이 {target}을 신고했습니다",
  "notification.admin.sign_up": "{name} 님이 가입했습니다",
  "notification.admin.sign_up.name_and_others": "{name} 외 {count, plural, other {# 명}}이 가입했습니다",
  "notification.annual_report.message": "{year} #Wrapstodon 이 기다리고 있습니다! 올 해 마스토돈에서 있었던 최고의 순간과 기억들을 열어보세요!",
  "notification.annual_report.view": "#Wrapstodon 보기",
  "notification.favourite": "{name} 님이 내 게시물을 좋아합니다",
  "notification.favourite.name_and_others_with_link": "{name} 외 <a>{count, plural, other {# 명}}</a>이 내 게시물을 좋아합니다",
  "notification.favourite_pm": "{name} 님이 내 개인 멘션을 마음에 들어합니다",
  "notification.favourite_pm.name_and_others_with_link": "{name} 외 <a>{count, plural, other {# 명}}</a>이 내 개인 멘션을 좋아합니다",
  "notification.follow": "{name} 님이 나를 팔로우했습니다",
  "notification.follow.name_and_others": "{name} 외 {count, plural, other {# 명}}이 날 팔로우했습니다",
  "notification.follow_request": "{name} 님이 팔로우 요청을 보냈습니다",
  "notification.follow_request.name_and_others": "{name} 외 {count, plural, other {# 명}}이 나에게 팔로우 요청을 보냈습니다",
  "notification.label.mention": "멘션",
  "notification.label.private_mention": "개인 멘션",
  "notification.label.private_reply": "개인 답글",
  "notification.label.quote": "{name} 님이 내 게시물을 인용했습니다",
  "notification.label.reply": "답글",
  "notification.mention": "멘션",
  "notification.mentioned_you": "{name} 님의 멘션",
  "notification.moderation-warning.learn_more": "더 알아보기",
  "notification.moderation_warning": "중재 경고를 받았습니다",
  "notification.moderation_warning.action_delete_statuses": "게시물 몇 개가 삭제되었습니다.",
  "notification.moderation_warning.action_disable": "계정이 비활성화되었습니다.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "게시물 몇 개가 민감함 처리되었습니다.",
  "notification.moderation_warning.action_none": "계정에 중재 경고를 받았습니다.",
  "notification.moderation_warning.action_sensitive": "앞으로의 게시물을 민감한 것으로 표시됩니다.",
  "notification.moderation_warning.action_silence": "계정이 제한되었습니다.",
  "notification.moderation_warning.action_suspend": "계정이 정지되었습니다.",
  "notification.own_poll": "설문을 마침",
  "notification.poll": "참여한 투표가 끝났습니다",
  "notification.quoted_update": "{name} 님이 내가 인용한 게시물을 수정했습니다",
  "notification.reblog": "{name} 님이 부스트했습니다",
  "notification.reblog.name_and_others_with_link": "{name} 외 <a>{count, plural, other {# 명}}</a>이 내 게시물을 부스트했습니다",
  "notification.relationships_severance_event": "{name} 님과의 연결이 끊어졌습니다",
  "notification.relationships_severance_event.account_suspension": "{from}의 관리자가 {target}를 정지시켰기 때문에 그들과 더이상 상호작용 할 수 없고 정보를 받아볼 수 없습니다.",
  "notification.relationships_severance_event.domain_block": "{from}의 관리자가 {target}를 차단하였고 여기에는 나의 {followersCount} 명의 팔로워와 {followingCount, plural, other {#}} 명의 팔로우가 포함되었습니다.",
  "notification.relationships_severance_event.learn_more": "더 알아보기",
  "notification.relationships_severance_event.user_domain_block": "내가 {target}를 차단하여 {followersCount} 명의 팔로워와 {followingCount, plural, other {#}} 명의 팔로우가 제거되었습니다.",
  "notification.status": "{name} 님이 방금 게시물을 올렸습니다",
  "notification.update": "{name} 님이 게시물을 수정했습니다",
  "notification_requests.accept": "수락",
  "notification_requests.accept_multiple": "{count, plural, other {#}} 개의 요청 수락하기",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {}}요청 수락하기",
  "notification_requests.confirm_accept_multiple.message": "{count, plural, other {#}} 개의 요청을 수락하려고 합니다. 계속 진행할까요?",
  "notification_requests.confirm_accept_multiple.title": "알림 요청을 수락할까요?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {요청 지우기}}",
  "notification_requests.confirm_dismiss_multiple.message": "{count, plural, other {# 개의 요청}}을 지우려고 합니다. {count, plural, other {}}다시 접근하기 어렵습니다. 계속할까요?",
  "notification_requests.confirm_dismiss_multiple.title": "알림 요청을 지울까요?",
  "notification_requests.dismiss": "지우기",
  "notification_requests.dismiss_multiple": "{count, plural, other {# 개의 요청 지우기}}",
  "notification_requests.edit_selection": "편집",
  "notification_requests.exit_selection": "완료",
  "notification_requests.explainer_for_limited_account": "이 계정은 중재자에 의해 제한되었기 때문에 이 계정의 알림은 걸러졌습니다.",
  "notification_requests.explainer_for_limited_remote_account": "이 계정 혹은 그가 속한 서버는 중재자에 의해 제한되었기 때문에 이 계정의 알림은 걸러졌습니다.",
  "notification_requests.maximize": "최대화",
  "notification_requests.minimize_banner": "걸러진 알림 배너 최소화",
  "notification_requests.notifications_from": "{name} 님으로부터의 알림",
  "notification_requests.title": "걸러진 알림",
  "notification_requests.view": "알림 보기",
  "notifications.clear": "알림 비우기",
  "notifications.clear_confirmation": "정말로 알림을 삭제하시겠습니까?",
  "notifications.clear_title": "알림을 모두 지울까요?",
  "notifications.column_settings.admin.report": "새 신고:",
  "notifications.column_settings.admin.sign_up": "새로운 가입:",
  "notifications.column_settings.alert": "데스크탑 알림",
  "notifications.column_settings.favourite": "좋아요:",
  "notifications.column_settings.filter_bar.advanced": "모든 범주 표시",
  "notifications.column_settings.filter_bar.category": "빠른 필터 막대",
  "notifications.column_settings.follow": "새 팔로워:",
  "notifications.column_settings.follow_request": "새 팔로우 요청:",
  "notifications.column_settings.group": "그룹화",
  "notifications.column_settings.mention": "멘션:",
  "notifications.column_settings.poll": "설문 결과:",
  "notifications.column_settings.push": "푸시 알림",
  "notifications.column_settings.quote": "인용:",
  "notifications.column_settings.reblog": "부스트:",
  "notifications.column_settings.show": "칼럼에서 보기",
  "notifications.column_settings.sound": "효과음 재생",
  "notifications.column_settings.status": "새 게시물:",
  "notifications.column_settings.unread_notifications.category": "읽지 않은 알림",
  "notifications.column_settings.unread_notifications.highlight": "읽지 않은 알림 강조",
  "notifications.column_settings.update": "수정내역:",
  "notifications.filter.all": "모두",
  "notifications.filter.boosts": "부스트",
  "notifications.filter.favourites": "좋아요",
  "notifications.filter.follows": "팔로우",
  "notifications.filter.mentions": "멘션",
  "notifications.filter.polls": "설문 결과",
  "notifications.filter.statuses": "팔로우 하는 사람들의 최신 게시물",
  "notifications.grant_permission": "권한 부여.",
  "notifications.group": "{count}개의 알림",
  "notifications.mark_as_read": "모든 알림을 읽은 상태로 표시",
  "notifications.permission_denied": "권한이 거부되었기 때문에 데스크탑 알림을 활성화할 수 없음",
  "notifications.permission_denied_alert": "이전에 브라우저 권한이 거부되었기 때문에, 데스크탑 알림이 활성화 될 수 없습니다.",
  "notifications.permission_required": "필요한 권한이 승인되지 않아 데스크탑 알림을 사용할 수 없습니다.",
  "notifications.policy.accept": "허용",
  "notifications.policy.accept_hint": "알림 목록에 표시",
  "notifications.policy.drop": "무시",
  "notifications.policy.drop_hint": "공허로 보내고, 다시는 보지 않습니다",
  "notifications.policy.filter": "필터",
  "notifications.policy.filter_hint": "걸러진 알림 목록으로 보내기",
  "notifications.policy.filter_limited_accounts_hint": "서버 중재자에 의해 제한된 계정들",
  "notifications.policy.filter_limited_accounts_title": "중재된 계정",
  "notifications.policy.filter_new_accounts.hint": "{days, plural, one {하루} other {#일}} 안에 만들어진",
  "notifications.policy.filter_new_accounts_title": "새 계정",
  "notifications.policy.filter_not_followers_hint": "나를 팔로우 한 지 {days, plural, other {# 일}}이 되지 않은 사람들을 포함",
  "notifications.policy.filter_not_followers_title": "나를 팔로우하지 않는 사람들",
  "notifications.policy.filter_not_following_hint": "내가 수동으로 승인하지 않는 한",
  "notifications.policy.filter_not_following_title": "내가 팔로우하지 않는 사람들",
  "notifications.policy.filter_private_mentions_hint": "내가 한 멘션에 단 답글이거나 내가 발신자를 팔로우 한 것이 아닌 이상 걸러집니다",
  "notifications.policy.filter_private_mentions_title": "청하지 않은 개인 멘션",
  "notifications.policy.title": "알림 조건 설정",
  "notifications_permission_banner.enable": "데스크탑 알림 활성화",
  "notifications_permission_banner.how_to_control": "마스토돈이 열려 있지 않을 때에도 알림을 받으려면, 데스크탑 알림을 활성화 하세요. 당신은 어떤 종류의 반응이 데스크탑 알림을 발생할 지를 {icon} 버튼을 통해 세세하게 설정할 수 있습니다.",
  "notifications_permission_banner.title": "아무것도 놓치지 마세요",
  "onboarding.follows.back": "뒤로가기",
  "onboarding.follows.empty": "안타깝지만 아직은 아무 것도 보여드릴 수 없습니다. 검색을 이용하거나 둘러보기 페이지에서 팔로우 할 사람을 찾을 수 있습니다. 아니면 잠시 후에 다시 시도하세요.",
  "onboarding.follows.search": "검색",
  "onboarding.follows.title": "사람들을 팔로우하기",
  "onboarding.profile.discoverable": "내 프로필을 발견 가능하도록 설정",
  "onboarding.profile.discoverable_hint": "마스토돈의 발견하기 기능에 참여하면 게시물이 검색 결과와 유행 란에 표시될 수 있고, 비슷한 관심사를 가진 사람들에게 자신의 프로필이 추천될 수 있습니다.",
  "onboarding.profile.display_name": "표시되는 이름",
  "onboarding.profile.display_name_hint": "진짜 이름 또는 재미난 이름…",
  "onboarding.profile.note": "자기소개",
  "onboarding.profile.note_hint": "남을 @mention 하거나 #hashtag 태그를 달 수 있습니다…",
  "onboarding.profile.title": "프로필 설정",
  "onboarding.profile.upload_avatar": "프로필 사진 업로드",
  "onboarding.profile.upload_header": "프로필 헤더 업로드",
  "password_confirmation.exceeds_maxlength": "암호 확인 값이 최대 암호 길이를 초과하였습니다",
  "password_confirmation.mismatching": "암호 확인 값이 일치하지 않습니다",
  "picture_in_picture.restore": "다시 넣기",
  "poll.closed": "마감",
  "poll.refresh": "새로고침",
  "poll.reveal": "결과 보기",
  "poll.total_people": "{count, plural, other {#}} 명",
  "poll.total_votes": "{count, plural, other {#}} 표",
  "poll.vote": "투표",
  "poll.voted": "이 답변에 투표함",
  "poll.votes": "{votes} 표",
  "poll_button.add_poll": "설문 추가",
  "poll_button.remove_poll": "설문 제거",
  "privacy.change": "게시물의 프라이버시 설정을 변경",
  "privacy.direct.long": "이 게시물에서 언급된 모두",
  "privacy.direct.short": "개인 멘션",
  "privacy.private.long": "내 팔로워만",
  "privacy.private.short": "팔로워",
  "privacy.public.long": "마스토돈 내외 모두",
  "privacy.public.short": "공개",
  "privacy.quote.anyone": "{visibility}, 인용 허용",
  "privacy.quote.disabled": "{visibility}, 인용 비활성",
  "privacy.quote.limited": "{visibility}, 제한된 인용",
  "privacy.unlisted.additional": "공개와 똑같지만 게시물이 실시간 피드나 해시태그, 둘러보기, (계정 설정에서 허용했더라도) 마스토돈 검색에서 제외됩니다.",
  "privacy.unlisted.long": "마스토돈 검색결과, 유행, 공개 타임라인에서 숨기기",
  "privacy.unlisted.short": "조용한 공개",
  "privacy_policy.last_updated": "{date}에 마지막으로 업데이트됨",
  "privacy_policy.title": "개인정보처리방침",
  "quote_error.edit": "게시물을 수정하면서 인용을 추가할 수 없습니다.",
  "quote_error.poll": "인용과 투표를 함께 사용할 수 없습니다.",
  "quote_error.private_mentions": "인용과 개인 멘션을 함께 사용할 수 없습니다.",
  "quote_error.quote": "한 번의 인용만 허용됩니다.",
  "quote_error.unauthorized": "이 게시물을 인용할 권한이 없습니다.",
  "quote_error.upload": "인용과 미디어 첨부를 함께 사용할 수 없습니다.",
  "recommended": "추천함",
  "refresh": "새로고침",
  "regeneration_indicator.please_stand_by": "잠시 기다려주세요.",
  "regeneration_indicator.preparing_your_home_feed": "홈 피드를 준비 중입니다…",
  "relative_time.days": "{number}일 전",
  "relative_time.full.days": "{number} 일 전",
  "relative_time.full.hours": "{number} 시간 전",
  "relative_time.full.just_now": "방금 전",
  "relative_time.full.minutes": "{number} 분 전",
  "relative_time.full.seconds": "{number} 초 전",
  "relative_time.hours": "{number}시간 전",
  "relative_time.just_now": "방금",
  "relative_time.minutes": "{number}분 전",
  "relative_time.seconds": "{number}초 전",
  "relative_time.today": "오늘",
  "remove_quote_hint.button_label": "알겠습니다",
  "remove_quote_hint.message": "{icon} 메뉴에서 할 수 있습니다.",
  "remove_quote_hint.title": "인용된 나의 게시물을 지우고 싶나요?",
  "reply_indicator.attachments": "{count, plural, other {#}} 개의 첨부파일",
  "reply_indicator.cancel": "취소",
  "reply_indicator.poll": "투표",
  "report.block": "차단",
  "report.block_explanation": "당신은 해당 계정의 게시물을 보지 않게 됩니다. 해당 계정은 당신의 게시물을 보거나 팔로우 할 수 없습니다. 해당 계정은 자신이 차단되었다는 사실을 알 수 있습니다.",
  "report.categories.legal": "법적인 문제",
  "report.categories.other": "기타",
  "report.categories.spam": "스팸",
  "report.categories.violation": "콘텐츠가 한 개 이상의 서버 규칙을 위반합니다",
  "report.category.subtitle": "가장 알맞은 것을 선택",
  "report.category.title": "이 {type}에 무슨 문제가 있는지 알려주세요",
  "report.category.title_account": "프로필",
  "report.category.title_status": "게시물",
  "report.close": "완료",
  "report.comment.title": "우리가 더 알아야 할 내용이 있나요?",
  "report.forward": "{target}에 전달",
  "report.forward_hint": "이 계정은 다른 서버에 있습니다. 익명화 된 사본을 해당 서버에도 전송할까요?",
  "report.mute": "뮤트",
  "report.mute_explanation": "당신은 해당 계정의 게시물을 보지 않게 됩니다. 해당 계정은 여전히 당신을 팔로우 하거나 당신의 게시물을 볼 수 있으며 해당 계정은 자신이 뮤트 되었는지 알지 못합니다.",
  "report.next": "다음",
  "report.placeholder": "추가 정보 입력",
  "report.reasons.dislike": "마음에 안 듭니다",
  "report.reasons.dislike_description": "원치 않는 게시물입니다",
  "report.reasons.legal": "불법입니다",
  "report.reasons.legal_description": "내 서버가 속한 국가의 법률을 위반한다고 생각합니다",
  "report.reasons.other": "기타",
  "report.reasons.other_description": "이슈가 다른 분류에 속하지 않습니다",
  "report.reasons.spam": "스팸입니다",
  "report.reasons.spam_description": "악성 링크, 반응 스팸, 또는 반복적인 답글",
  "report.reasons.violation": "서버 규칙을 위반합니다",
  "report.reasons.violation_description": "특정 규칙을 위반합니다",
  "report.rules.subtitle": "해당하는 사항을 모두 선택",
  "report.rules.title": "어떤 규칙을 위반했나요?",
  "report.statuses.subtitle": "해당하는 사항을 모두 선택",
  "report.statuses.title": "이 신고에 대해서 더 참고해야 할 게시물이 있나요?",
  "report.submit": "신고하기",
  "report.target": "{target} 신고하기",
  "report.thanks.take_action": "마스토돈에서 나에게 보이는 것을 조절하기 위한 몇 가지 선택사항들이 존재합니다:",
  "report.thanks.take_action_actionable": "서버의 중재자들이 이것을 심사하는 동안, 당신은 @{name}에 대한 행동을 취할 수 있습니다:",
  "report.thanks.title": "이런 것을 보지 않길 원하나요?",
  "report.thanks.title_actionable": "신고해주셔서 감사합니다, 중재자분들이 확인할 예정입니다.",
  "report.unfollow": "@{name}을 팔로우 해제",
  "report.unfollow_explanation": "이 계정을 팔로우하고 있습니다. 홈 피드에서 더 이상 게시물을 받아 보지 않으려면 팔로우를 해제하십시오.",
  "report_notification.attached_statuses": "{count}개의 게시물 첨부됨",
  "report_notification.categories.legal": "법령",
  "report_notification.categories.legal_sentence": "불법적인 내용",
  "report_notification.categories.other": "기타",
  "report_notification.categories.other_sentence": "기타",
  "report_notification.categories.spam": "스팸",
  "report_notification.categories.spam_sentence": "스팸",
  "report_notification.categories.violation": "규칙 위반",
  "report_notification.categories.violation_sentence": "규칙 위반",
  "report_notification.open": "신고 열기",
  "search.clear": "검색 초기화",
  "search.no_recent_searches": "최근 검색 기록이 없습니다",
  "search.placeholder": "검색",
  "search.quick_action.account_search": "{x}에 맞는 프로필",
  "search.quick_action.go_to_account": "{x} 프로필로 이동",
  "search.quick_action.go_to_hashtag": "{x} 해시태그로 이동",
  "search.quick_action.open_url": "마스토돈에서 URL 열기",
  "search.quick_action.status_search": "{x}에 맞는 게시물",
  "search.search_or_paste": "검색하거나 URL 붙여넣기",
  "search_popout.full_text_search_disabled_message": "{domain}에서는 이용할 수 없습니다.",
  "search_popout.full_text_search_logged_out_message": "로그인되어 있을 때만 할 수 있습니다.",
  "search_popout.language_code": "ISO 언어코드",
  "search_popout.options": "검색 옵션",
  "search_popout.quick_actions": "빠른 작업",
  "search_popout.recent": "최근 검색",
  "search_popout.specific_date": "특정 날짜",
  "search_popout.user": "사용자",
  "search_results.accounts": "프로필",
  "search_results.all": "전부",
  "search_results.hashtags": "해시태그",
  "search_results.no_results": "결과가 없습니다.",
  "search_results.no_search_yet": "게시물, 프로필, 해시태그를 검색해보세요.",
  "search_results.see_all": "모두 보기",
  "search_results.statuses": "게시물",
  "search_results.title": "\"{q}\"에 대한 검색",
  "server_banner.about_active_users": "30일 동안 이 서버를 사용한 사람들 (월간 활성 이용자)",
  "server_banner.active_users": "활성 사용자",
  "server_banner.administered_by": "관리자:",
  "server_banner.is_one_of_many": "{domain}은 페디버스를 통해 참여할 수 있는 많은 마스토돈 서버들 중 하나입니다",
  "server_banner.server_stats": "서버 통계:",
  "sign_in_banner.create_account": "계정 생성",
  "sign_in_banner.follow_anyone": "페디버스를 통해 누구든지 팔로우하고 시간순으로 게시물을 받아보세요. 알고리즘도, 광고도, 클릭을 유도하는 것들도 없습니다.",
  "sign_in_banner.mastodon_is": "마스토돈은 무엇이 일어나는지 받아보는 가장 좋은 수단입니다.",
  "sign_in_banner.sign_in": "로그인",
  "sign_in_banner.sso_redirect": "로그인 또는 가입하기",
  "status.admin_account": "@{name}에 대한 중재 화면 열기",
  "status.admin_domain": "{domain}에 대한 중재 화면 열기",
  "status.admin_status": "중재 화면에서 이 게시물 열기",
  "status.all_disabled": "부스트와 인용이 비활성화되었습니다",
  "status.block": "@{name} 차단",
  "status.bookmark": "북마크",
  "status.cancel_reblog_private": "부스트 취소",
  "status.cannot_quote": "인용을 비허용한 게시물",
  "status.cannot_reblog": "이 게시물은 부스트 할 수 없습니다",
  "status.contains_quote": "인용 포함",
  "status.context.loading": "더 많은 답글 불러오는 중",
  "status.context.loading_error": "새 답글을 불러올 수 없습니다",
  "status.context.loading_success": "새 답글을 불러왔습니다",
  "status.context.more_replies_found": "답글을 더 찾았습니다",
  "status.context.retry": "재시도",
  "status.context.show": "보기",
  "status.continued_thread": "이어지는 글타래",
  "status.copy": "게시물 링크 복사",
  "status.delete": "삭제",
  "status.delete.success": "게시물 삭제됨",
  "status.detailed_status": "대화 자세히 보기",
  "status.direct": "@{name} 님에게 개인 멘션",
  "status.direct_indicator": "개인 멘션",
  "status.edit": "수정",
  "status.edited": "{date}에 마지막으로 편집됨",
  "status.edited_x_times": "{count, plural, other {{count}}} 번 수정됨",
  "status.embed": "임베드 코드 받기",
  "status.favourite": "좋아요",
  "status.favourites_count": "{count, plural, other {{counter}}} 마음에 들어함",
  "status.filter": "이 게시물을 필터",
  "status.history.created": "{name} 님이 {date}에 게시함",
  "status.history.edited": "{name} 님이 {date}에 수정함",
  "status.load_more": "더보기",
  "status.media.open": "클릭하여 열기",
  "status.media.show": "클릭하여 보기",
  "status.media_hidden": "미디어 숨겨짐",
  "status.mention": "@{name} 님에게 멘션",
  "status.more": "자세히",
  "status.mute": "@{name} 뮤트",
  "status.mute_conversation": "대화 뮤트",
  "status.open": "상세 정보 표시",
  "status.pin": "고정",
  "status.quote": "인용",
  "status.quote.cancel": "인용 취소",
  "status.quote_error.blocked_account_hint.title": "@{name} 님을 차단했기 때문에 이 게시물은 숨겨졌습니다.",
  "status.quote_error.blocked_domain_hint.title": "{domain}을 차단했기 때문에 이 게시물은 숨겨졌습니다.",
  "status.quote_error.filtered": "필터에 의해 가려짐",
  "status.quote_error.limited_account_hint.action": "그냥 보기",
  "status.quote_error.limited_account_hint.title": "이 계정은 {domain}의 중재자에 의해 숨겨진 상태입니다.",
  "status.quote_error.muted_account_hint.title": "@{name}을 뮤트했기 때문에 이 게시물은 숨겨졌습니다.",
  "status.quote_error.not_available": "게시물 사용 불가",
  "status.quote_error.pending_approval": "게시물 대기중",
  "status.quote_error.pending_approval_popout.body": "Mastodon에서는 타인이 인용할 수 있는지 여부를 제어할 수 있습니다. 이 게시물은 원저자의 승인을 얻을 때까지 계류됩니다.",
  "status.quote_error.revoked": "원작성자에 의해 게시물 삭제됨",
  "status.quote_followers_only": "팔로워만 인용할 수 있는 게시물",
  "status.quote_manual_review": "작성자가 직접 검토합니다",
  "status.quote_noun": "인용",
  "status.quote_policy_change": "누가 인용할 수 있는지",
  "status.quote_post_author": "인용된 @{name} 님의 게시물",
  "status.quote_private": "비공개 게시물은 인용할 수 없습니다",
  "status.quotes.empty": "아직 아무도 이 게시물을 인용하지 않았습니다. 누군가 인용한다면 여기에 표시됩니다.",
  "status.quotes.local_other_disclaimer": "원작자가 거부한 인용은 표시되지 않습니다.",
  "status.quotes.remote_other_disclaimer": "{domain}의 인용만 여기에 확정적으로 보여집니다. 원작자가 거부한 인용은 보여지지 않습니다.",
  "status.quotes_count": "{count, plural, other {{counter}}} 인용",
  "status.read_more": "더 보기",
  "status.reblog": "부스트",
  "status.reblog_or_quote": "부스트 또는 인용",
  "status.reblog_private": "팔로워들에게 다시 공유",
  "status.reblogged_by": "{name} 님이 부스트했습니다",
  "status.reblogs.empty": "아직 아무도 이 게시물을 부스트하지 않았습니다. 부스트 한 사람들이 여기에 표시 됩니다.",
  "status.reblogs_count": "{count, plural, other {{counter}}} 부스트",
  "status.redraft": "지우고 다시 쓰기",
  "status.remove_bookmark": "북마크 삭제",
  "status.remove_favourite": "즐겨찾기에서 제거",
  "status.remove_quote": "삭제",
  "status.replied_in_thread": "글타래에 답장",
  "status.replied_to": "{name} 님에게",
  "status.reply": "답장",
  "status.replyAll": "글타래에 답장",
  "status.report": "@{name} 신고하기",
  "status.request_quote": "인용 요청",
  "status.revoke_quote": "내 게시물을 @{name}의 게시물에서 삭제",
  "status.sensitive_warning": "민감한 내용",
  "status.share": "공유",
  "status.show_less_all": "모두 접기",
  "status.show_more_all": "모두 펼치기",
  "status.show_original": "원본 보기",
  "status.title.with_attachments": "{user} 님이 {attachmentCount, plural, one {첨부파일} other {{attachmentCount}개의 첨부파일}}과 함께 게시함",
  "status.translate": "번역",
  "status.translated_from_with": "{provider}에 의해 {lang}에서 번역됨",
  "status.uncached_media_warning": "미리보기를 사용할 수 없습니다",
  "status.unmute_conversation": "이 대화의 뮤트 해제하기",
  "status.unpin": "고정 해제",
  "subscribed_languages.lead": "변경 후에는 선택한 언어들로 작성된 게시물들만 홈 타임라인과 리스트 타임라인에 나타나게 됩니다. 아무 것도 선택하지 않으면 모든 언어로 작성된 게시물을 받아봅니다.",
  "subscribed_languages.save": "변경사항 저장",
  "subscribed_languages.target": "{target}에 대한 구독 언어 변경",
  "tabs_bar.home": "홈",
  "tabs_bar.menu": "메뉴",
  "tabs_bar.notifications": "알림",
  "tabs_bar.publish": "새 게시물",
  "tabs_bar.search": "검색",
  "terms_of_service.effective_as_of": "{date}부터 적용됨",
  "terms_of_service.title": "이용 약관",
  "terms_of_service.upcoming_changes_on": "{date}에 예정된 변경사항",
  "time_remaining.days": "{number} 일 남음",
  "time_remaining.hours": "{number} 시간 남음",
  "time_remaining.minutes": "{number} 분 남음",
  "time_remaining.moments": "남은 시간",
  "time_remaining.seconds": "{number} 초 남음",
  "trends.counter_by_accounts": "이전 {days}일 동안 {counter} 명의 사용자",
  "trends.trending_now": "지금 유행 중",
  "ui.beforeunload": "지금 나가면 저장되지 않은 항목을 잃게 됩니다.",
  "units.short.billion": "{count}십억",
  "units.short.million": "{count}백만",
  "units.short.thousand": "{count}천",
  "upload_area.title": "드래그 & 드롭으로 업로드",
  "upload_button.label": "이미지, 영상, 오디오 파일 추가",
  "upload_error.limit": "파일 업로드 제한에 도달했습니다.",
  "upload_error.poll": "파일 업로드는 설문과 함께 쓸 수 없습니다.",
  "upload_error.quote": "파일 업로드는 인용과 함께 쓸 수 없습니다.",
  "upload_form.drag_and_drop.instructions": "미디어 첨부파일을 집으려면 스페이스나 엔터를 누르세요. 드래그 하는 동안 방향키를 이용해 원하는 방향으로 이동할 수 있습니다. 스페이스나 엔터를 다시 눌러 새 위치에 놓거나 ESC를 이용해 취소할 수 있습니다.",
  "upload_form.drag_and_drop.on_drag_cancel": "드래그가 취소되었습니다. 미디어 첨부파일 {item}은 이동되지 않았습니다.",
  "upload_form.drag_and_drop.on_drag_end": "미디어 첨부파일 {item}은 이동되지 않았습니다.",
  "upload_form.drag_and_drop.on_drag_over": "미디어 첨부파일 {item}이 이동되었습니다.",
  "upload_form.drag_and_drop.on_drag_start": "미디어 첨부파일 {item}을 집었습니다.",
  "upload_form.edit": "수정",
  "upload_progress.label": "업로드 중...",
  "upload_progress.processing": "처리 중...",
  "username.taken": "이미 사용중인 사용자명입니다. 다시 시도해보세요",
  "video.close": "동영상 닫기",
  "video.download": "파일 다운로드",
  "video.exit_fullscreen": "전체화면 나가기",
  "video.expand": "동영상 확장",
  "video.fullscreen": "전체화면",
  "video.hide": "동영상 숨기기",
  "video.mute": "음소거",
  "video.pause": "일시정지",
  "video.play": "재생",
  "video.skip_backward": "뒤로 건너뛰기",
  "video.skip_forward": "앞으로 건너뛰기",
  "video.unmute": "음소거 해제",
  "video.volume_down": "음량 감소",
  "video.volume_up": "음량 증가",
  "visibility_modal.button_title": "공개범위 설정",
  "visibility_modal.direct_quote_warning.text": "현재 설정을 저장하면 포함된 인용은 링크로 변환됩니다.",
  "visibility_modal.direct_quote_warning.title": "비공개 멘션에는 게시물을 인용할 수 없습니다",
  "visibility_modal.header": "공개범위와 반응",
  "visibility_modal.helper.direct_quoting": "마스토돈에서 작성한 개인 멘션은 타인이 인용할 수 없습니다.",
  "visibility_modal.helper.privacy_editing": "공개범위는 게시한 다음 수정할 수 없습니다.",
  "visibility_modal.helper.privacy_private_self_quote": "자신의 비공개 게시물을 공개 게시물로 인용할 수 없습니다.",
  "visibility_modal.helper.private_quoting": "마스토돈에서 작성된 팔로워 전용 게시물은 다른 사용자가 인용할 수 없습니다.",
  "visibility_modal.helper.unlisted_quoting": "사람들에게 인용된 경우, 인용한 게시물도 유행 타임라인에서 감추게 됩니다.",
  "visibility_modal.instructions": "누가 이 게시물과 상호작용할 수 있는 지 제어합니다. 또한 <link>환경설정 > 게시물 기본설정</link>으로 이동해 향후 모든 게시물의 설정을 적용할 수 있습니다.",
  "visibility_modal.privacy_label": "공개 범위",
  "visibility_modal.quote_followers": "팔로워만",
  "visibility_modal.quote_label": "인용할 수 있는 사람",
  "visibility_modal.quote_nobody": "나에게만",
  "visibility_modal.quote_public": "아무나",
  "visibility_modal.save": "저장"
}
